import styled from 'styled-components';

import { zIndex, breakpoints, colors, fontFamily } from '../../ui/variables';

const main = {
  height: {
    iphone: 48,
  },
};

export const EditInstitutionFormStyle = styled.div`
  ${zIndex.sky};
  align-items: center;
  background-color: white;
  border-top-left-radius: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-height: calc(100vh - ${main.height.iphone}px);
  overflow-y: auto;
  padding-top: 170px;
  position: fixed;
  right: -120%;
  top: ${main.height.iphone}px;
  transition: 600ms right;
  width: 100%;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    align-items: flex-start;
    flex-direction: row-reverse;
    height: 95%;
    justify-content: center;
    width: 60%;
  }

  @media (min-width: ${breakpoints.hd.width}px) {
    width: calc(100% - 380px);
  }

  &.opened-form {
    right: 0;
  }

  .error-message {
    ${fontFamily.sourceSansPro.bold};
    color: ${colors.softRed};
    font-size: 14px;
    margin-top: 3px;
  }

  .back-button-container {
    align-items: center;
    display: flex;
    left: 50px;
    position: absolute;
    top: 35px;

    @media (min-width: ${breakpoints.hd.width}px) {
      top: 55px;
    }

    .back {
      svg {
        fill: ${colors.veryDarkGray};
        height: 16px;
        margin-right: 12px;
        width: 20px;
      }
    }
  }

  .header-form {
    left: 75px;
    position: absolute;
    top: 100px;

    .title-header {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.veryDarkGray};
      font-size: 18px;
    }
  }

  .logo-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      align-items: flex-start;
      justify-content: flex-start;
      padding-left: 10%;
      padding-top: 50px;
      width: 70%;
    }

    .input-file {
      cursor: pointer;
      height: 218px;
      opacity: 0;
      position: absolute;
      width: 218px;
    }

    .image-label {
      font-size: 14px;
      margin-bottom: 15px;
      width: 30%;
    }

    .logo {
      align-items: center;
      background-color: ${colors.mostlyWhite};
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 50%;
      display: flex;
      height: 218px;
      justify-content: center;
      position: relative;
      width: 218px;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        height: 218px;
        width: 218px;
        border-radius: 50%;
      }

      .edit-image {
        border-radius: 50%;
        height: 218px;
        width: 218px;
      }

      .add {
        align-items: center;
        background-color: ${colors.softBlue};
        border-radius: 50%;
        display: flex;
        height: 44px;
        justify-content: center;
        position: absolute;
        right: -22px;
        width: 44px;

        svg {
          fill: white;
          height: 22px;
          width: 22px;
        }
      }
    }

    .add-logo {
      ${fontFamily.sourceSansPro.normal};
      color: ${colors.veryDarkGrayishBlue};
      margin-top: 18px;
    }
  }

  .data-column {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 40px;
    padding-left: 6%;
    padding-right: 6%;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      margin-top: 0;
      padding-left: 6%;
      padding-right: 0%;
      width: 75%;
    }

    .institution-data-form {
      width: 100%;

      .input-label-form {
        display: flex;
        flex-direction: column;
        height: 70px;
        justify-content: space-between;
        margin-bottom: 20px;
        margin-top: 30px;
        width: 100%;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          align-items: center;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
        }

        &.select-add-responsible {
          align-items: flex-start;
          display: flex;
          flex-direction: column;
          width: 100%;

          .label {
            width: 100%;

            @media (min-width: ${breakpoints.wxgaPlus.width}px) {
              width: 27%;
            }
          }

          .input {
            margin-top: 5px;
            width: 100%;
          }
        }

        .label {
          width: 100%;

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            width: 20%;
          }
        }

        .input {
          width: 100%;

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            width: 78%;
          }
        }
      }

      .add-responsible {
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.veryDarkGrayishBlue};
        font-size: 14px;
        width: 100%;
      }
    }

    .administrator-form {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin-top: 35px;
      width: 100%;

      .select-label-wrapper {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-top: 20px;
        width: 100%;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          align-items: center;
          flex-direction: row;
        }

        .label-wrapper {
          width: 25%;
        }

        .select-input-wrapper {
          display: flex;
          margin-top: 5px;
          width: 100%;

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            margin-top: 0px;
            width: 100%;
          }

          .select-wrapper {
            margin-right: 4%;
            width: 25%;
          }

          .input-element-wrapper {
            width: 100%;

            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              width: 75%;
            }
          }
        }
      }
    }

    .healthscan-plan-form {
      margin-top: 64px;
    }

    .buttons-container {
      display: flex;
      flex-direction: row;
      height: 100px;
      justify-content: space-between;
      margin-top: 80px;
      width: 100%;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        width: 100%;
      }

      .button-wrapper {
        height: 80px;
        width: 45%;
      }
    }

    .subtitle-institution-form {
      ${fontFamily.sourceSansPro.bold};
      color: ${colors.veryDarkGray};
      font-size: 14px;
      line-height: 18px;
    }

    .text-form {
      font-size: 12px;
      margin-top: 16px;
      width: 90%;
      word-break: keep-all;
    }

    .input-label-wrapper,
    .select-label-wrapper {
      .label-wrapper {
        .required-field {
          color: ${colors.softRed};
        }
      }
    }

    .input-label-wrapper {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin-top: 20px;
      width: 100%;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        align-items: center;
        flex-direction: row;
        justify-content: center;
      }

      .label-wrapper {
        width: 20%;
      }

      .input-element-wrapper {
        margin-top: 5px;
        width: 100%;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          margin-top: 0px;
          width: 80%;
        }
      }
    }

    .side-by-side-inputs {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;

      .input-label-wrapper {
        &:first-child {
          margin-right: 2%;

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 43%;
            min-width: 43%;
          }
        }

        .label-wrapper {
          max-width: 50%;
          min-width: 50%;
        }
      }

      .input-label-wrapper {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-right: 0;
        margin-top: 20px;
        width: 100%;

        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          justify-content: center;
          max-width: 50%;
          min-width: 50%;
        }

        .label-wrapper {
          margin-left: 0;
          width: 30%;
        }

        .input-element-wrapper {
          margin-top: 5px;
          width: 100%;

          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            width: 100%;
          }
        }
      }
    }
  }
`;
